import { spin } from '../../Styles/keyframes'
import { styled } from '../../Styles/stitches.config'
import Button from '../Button'

export const LoadingAnimation = styled('div', {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    size: 16,

    div: {
        animation: `${spin} 1s ease infinite`,
        border: '2px solid $primary400',
        borderColor: '$primary400 transparent transparent transparent',
        br: '50%',
        position: 'absolute',
        size: '100%',

        '&:nth-child(1)': {
            animationDelay: '-0.3s',
        },
        '&:nth-child(2)': {
            animationDelay: '-0.2s',
        },
        '&:nth-child(3)': {
            animationDelay: '-0.1s',
        },
    },
})

export const StyledLoadingButton = styled(Button, {
    position: 'relative',
    variants: {
        loading: {
            true: {
                [`> *:not(${LoadingAnimation})`]: {
                    visibility: 'hidden',
                    opacity: 0,
                },
            },
        },
    },
})
